/* istanbul ignore file */
/**
 * @fileoverview This module is responsible for initializing and provisioning
 * the logger module to the frontend application.
 * @note This is a side-effect module, importing it anywhere
 * will ensure it runs once
 * (see https://hacks.mozilla.org/2018/03/es-modules-a-cartoon-deep-dive/).
 */
import { initializeLogger } from './init.logger';

/**
 * The logger module is stateful and requires instantiation
 */
initializeLogger();

/**
 * By consuming this exported `getLogger` we guarantee the
 * logger is initialized and ready to be used by modules within
 * the frontend.
 */
export {
  _getLogger as getLogger,
  getLoggerContext,
  setLoggerContext,
  updateLoggerContext,
  clearLoggerContext,
} from '@doxyme/analytics';
